<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'

export default {
  mixins: [fandomBasicMixin],
  props: {
    selectedIndex: Number,
  },
  data: function() {
    return {
    };
  },
  computed: {
    indexChar() {
      const cmp = this;
      return String.fromCharCode(cmp.selectedIndex + 65);
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<template>
  <div 
    :class="contentType" 
    v-easyadmin="easyadminId" 
    v-if="isContentVisibleToUser()" 
    class="row w-100 mh-100vh mx-0 justify-content-center" 
    pin-content-component
  >
    <div class="col-12 col-md-5 bg-cover-center image-column" v-if="content.image" :style="{'background-image': `url(${content.image.url})`}">
    </div>
    <div class="col-12 col-md-7 d-flex flex-column justify-content-md-center text-column">
      <div class="mb-4 mb-md-5 w-100 d-flex align-items-center" modal-carousel-heading-component>
        <div class="first-number mr-3">{{ indexChar }}</div>
        <div>{{content.category}}</div>
      </div>
      <component 
        v-if="content.title" 
        :is="content.title_tag || 'h3'"
        class="h1"
      >{{content.title}}</component>
      <component
        v-if="content.description"
        :is="content.description_tag || 'p'"
        v-html="content.description"
      ></component>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[pin-content-component] {
  [modal-carousel-heading-component] {
    font-size: 1.5rem;
    font-weight: 600;
    height: fit-content;

    .first-number {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 3.75rem;
      height: 3.75rem;
      background-color: $dark;
      color: $white;
      border-radius: 100%;
    }
  }

  .text-column {
    padding: 6rem;
  }

  @include media-breakpoint-down(sm) {
    .text-column {
      padding: 1.5rem;
    }

    .image-column {
      padding-bottom: 100%;
    }
  }
}
</style>